import { getValueFromId } from '../../helpers/functions';

export const createPrixPierreRevient = (pierre, poids, cours) => {
  const coursEurDoll = getValueFromId('1', cours) || 1;
  const prix = (parseFloat(pierre.euro) > 0)
    ? parseFloat(pierre.euro)
    : (parseFloat(pierre.dollar) || 0) / (coursEurDoll || 1);
  return (parseFloat(poids) * prix) || 0;
};

export const createPrixCoefPierre = (prixRevient, coef) =>
  (prixRevient * parseFloat(coef)) || 0;
